import { render, staticRenderFns } from "./BButtonSendEmailToSeveral.vue?vue&type=template&id=217e8c6f&"
import script from "./BButtonSendEmailToSeveral.vue?vue&type=script&lang=js&"
export * from "./BButtonSendEmailToSeveral.vue?vue&type=script&lang=js&"
import style0 from "./BButtonSendEmailToSeveral.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports